module.exports = __webpack_public_path__ + "static/img/product_1.5ce9cba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_1.png
// module id = j7Gm
// module chunks = 1